<template>
    <div>
        <div class="form-row mb-0" v-if="displayEntities">

            <base-select class="col-lg-4 mb-2"
                :placeholder="$t('common.entity')"
                v-model="filters.entity_id"
                :options="filters.options.entities"
                clearable>
            </base-select>

            <base-select class="col-lg-4 mb-2"
                :placeholder="$t('common.client')"
                v-model="filters.client_id"
                :options="filters.options.clients"
                clearable>
            </base-select>

            <base-select class="col-lg-4 mb-2"
                :placeholder="$t('common.access')"
                v-model="filters.access_id"
                :options="filters.options.accesses"
                clearable>
            </base-select>

        </div>
        <div class="form-row mb-0" v-else>

            <base-select class="col-lg-6 mb-2"
                :placeholder="$t('common.client')"
                v-model="filters.client_id"
                :options="filters.options.clients"
                clearable>
            </base-select>

            <base-select class="col-lg-6 mb-2"
                :placeholder="$t('common.access')"
                v-model="filters.access_id"
                :options="filters.options.accesses"
                clearable>
            </base-select>

        </div>
    </div>
</template>

<script>
    export default {

        data() {
            return {
                filters: this.$xapi.filters.context
            }
        },

        created() {
            this.filters.watch(this, '$xapi.filters.context')
            this.filters.entity_id = this.$auth.user.entity_id
        },

        computed: {

            displayEntities() {
                return Object.keys(this.filters.options.entities).length > 0
                    && !this.$auth.user.entity_id
            }
        }
    }
</script>
